import { configureStore } from '@reduxjs/toolkit'
import { commonSlice } from './common.slice'
import { kioskAuthSlice } from './kioskAuthSlice'
import { publicStore } from './public/public'
import { secureStore } from './secure/secure'
import { promptsStore } from './secure/prompts'
import { commonStore } from './public/common'
import { accountStore } from './secure/api.account'
import { solutionStore } from './secure/api.solution'
import { promptStore } from './secure/api.prompts'
import { adminStore } from './secure/api.admin'
import { flightStore } from './secure/api.flights'
import { agentStore } from './secure/api.agents'
import { kioskStore } from './secure/api.kiosk'
import { integerationStore } from './secure/api.integrations'
import { companyStore } from './secure/api.company'
import { rtkQueryErrorLogger } from './rtk-query-error-logger'

import { breadcrumbMiddleware } from './breadcrumb-middleware';

export const store = configureStore({
  reducer: {
    [commonSlice.name]: commonSlice.reducer,
    [kioskAuthSlice.name]: kioskAuthSlice.reducer,
    [publicStore.reducerPath]: publicStore.reducer,
    [secureStore.reducerPath]: secureStore.reducer,
    [promptsStore.reducerPath]: promptsStore.reducer,
    [commonStore.reducerPath]: commonStore.reducer,
    [accountStore.reducerPath]: accountStore.reducer,
    [solutionStore.reducerPath]: solutionStore.reducer,
    [promptStore.reducerPath]: promptStore.reducer,
    [adminStore.reducerPath]: adminStore.reducer,
    [flightStore.reducerPath]: flightStore.reducer,
    [agentStore.reducerPath]: agentStore.reducer,
    [kioskStore.reducerPath]: kioskStore.reducer,
    [integerationStore.reducerPath]: integerationStore.reducer,
    [companyStore.reducerPath]: companyStore.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
    breadcrumbMiddleware, 
    rtkQueryErrorLogger, 
    publicStore.middleware, 
    secureStore.middleware, 
    promptsStore.middleware, 
    commonStore.middleware, 
    accountStore.middleware, 
    solutionStore.middleware, 
    promptStore.middleware, 
    adminStore.middleware, 
    flightStore.middleware, 
    agentStore.middleware, 
    kioskStore.middleware, 
    integerationStore.middleware, 
    companyStore.middleware
  ),
})


// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
